import { Link } from "react-router-dom";
import { works } from "@/mocks/works";

const medals = ["ri-medal-2-fill text-accent-500", "ri-medal-fill text-secondary-400", "ri-medal-fill text-secondary-500"];

export default function RankingSection() {
  const ranking = [...works].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section className="bg-background-100 py-14 md:py-20" aria-labelledby="rank-heading">
      <div className="container-x grid gap-8 lg:grid-cols-3">
        <div className="lg:col-span-1">
          <span className="text-xs font-semibold uppercase tracking-wider text-primary-600">
            人气排行榜
          </span>
          <h2 id="rank-heading" className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            本周热读 TOP 5
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            综合读者热度与收藏整理的近期人气榜单。想快速入坑，从这些高热度作品开始准没错，每一部都足够精彩。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-secondary-600"
          >
            <i className="ri-question-line" />
            追更攻略
          </Link>
        </div>

        <div className="flex flex-col gap-3 lg:col-span-2">
          {ranking.map((w, i) => (
            <Link
              key={w.id}
              to={`/work/${w.id}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
            >
              <span className="flex w-9 shrink-0 items-center justify-center">
                {i < 3 ? (
                  <i className={`${medals[i]} text-2xl`} />
                ) : (
                  <span className="font-heading text-lg font-black text-foreground-400">{i + 1}</span>
                )}
              </span>
              <img
                src={w.cover}
                alt={`${w.title} 封面`}
                className="h-14 w-11 shrink-0 rounded-md object-cover object-top"
              />
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                  {w.title}
                </h3>
                <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line text-secondary-500" />
                    {(w.heat / 1000).toFixed(1)}k 热度
                  </span>
                  <span className="flex items-center gap-1 font-medium text-accent-600">
                    <i className="ri-star-fill" /> {w.rating.toFixed(1)}
                  </span>
                </p>
              </div>
              <span className="hidden shrink-0 items-center gap-1 text-xs text-foreground-500 sm:flex">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}